import React from "react"

 function Footer(props){
    return(
        <div className="footer">
            <p>{props.frase}</p>
        </div>
    )
}

export default Footer;